import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'call',
	landing: {
		ids: ['loader-main'],
		route: {
			path: '/call',
			name: 'call-funnel',
		},
	},
	funnel: {
		id: 'ob-call-funnel',
		route: {
			path: '/call/ob/:page*',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'call-onboarding',
		},
		slug: 'call',
		theme: 'light',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-main',
	},
	upsell: {
		routeNames: ['upsell-static-subscription-activated', 'upsell-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
